import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-content-center" }
const _hoisted_2 = { class: "grid col-12 lg:col-10 xl:col-7 justify-content-center pb-5" }
const _hoisted_3 = {
  class: "grid col-11 justify-content-center pb-2 pt-2 mt-4 mb-4",
  style: {"position":"relative"}
}
const _hoisted_4 = { class: "grid col-12 md:col-4 lg:col-4 justify-content-center" }
const _hoisted_5 = { class: "grid justify-content-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "col-12" }, " Download PDF", -1)
const _hoisted_7 = { class: "grid col-12 md:col-4 lg:col-4 justify-content-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "grid justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-envelope col-12",
    style: {"font-size":"7rem"}
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "col-12" }, " Email PDF")
], -1)
const _hoisted_9 = { class: "grid col-12 md:col-4 lg:col-4 justify-content-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "grid justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-arrow-right col-12",
    style: {"font-size":"7rem"}
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "col-12" }, "Create New Order")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineMessage = _resolveComponent("InlineMessage")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SendOrderDialog = _resolveComponent("SendOrderDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_InlineMessage, {
            severity: "success",
            class: "w-12 xl:w-11 m-0 lg:ml-3 lg:mr-3 xl:ml-2 xl:mr-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Order " + _toDisplayString(_ctx.getLastOrderId) + " has been created ", 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            class: "m-3 confirmation-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleGetOrderPDF(_ctx.getLastOrderId)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.orderPDFIcon(_ctx.getLastOrderId)),
                  style: {"font-size":"7rem"}
                }, null, 2),
                _hoisted_6
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Button, {
            class: "m-3 confirmation-btn",
            onClick: _ctx.handleEmailPDF
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Button, {
            class: "m-3 confirmation-btn",
            onClick: _ctx.handleContinueShopping
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _createVNode(_component_SendOrderDialog, {
      title: `Send order ${_ctx.getLastOrderId} by email`,
      visible: _ctx.showEmailPDFDialog,
      orderId: _ctx.getLastOrderId,
      onOnCloseDialog: _ctx.handleCloseEmailDialog,
      onOnSendEmail: _ctx.handleSendEmail,
      loading: _ctx.emailLoading
    }, null, 8, ["title", "visible", "orderId", "onOnCloseDialog", "onOnSendEmail", "loading"])
  ], 64))
}